document.addEventListener("DOMContentLoaded", function () {

    document.querySelectorAll(".eq_header_search").forEach(trigger => {

        const header = trigger.closest(".eq-header");
        const searchPopup = trigger.closest(".eq_mobile_header")
            ? trigger.closest(".eq_mobile_header").querySelector(".custom-search-popup")
            : header.querySelector(".custom-search-popup:not(.mobile-search-popup)");
        let closeTimeout = null;

        trigger.addEventListener("click", function (e) {
            e.preventDefault();

            if (closeTimeout) {
                clearTimeout(closeTimeout);
                closeTimeout = null;
            }

            header.classList.remove("eq-search-closing");
            searchPopup.classList.add("is-visible");
            header.classList.add("eq-search-open");
            searchPopup.querySelector('.custom-field__input').focus();
        });

        const resetButton = searchPopup.querySelector(".custom-reset__button");

        if (resetButton) {
            resetButton.addEventListener("click", function (e) {
                e.preventDefault();
                closeSearch();
            });
        }

        function closeSearch() {
            header.classList.remove("eq-search-open");
            header.classList.add("eq-search-closing");

            closeTimeout = setTimeout(function () {
                searchPopup.classList.remove("is-visible");
                header.classList.remove("eq-search-closing");
                closeTimeout = null;
            }, 1000); // matches the 1s animation duration in CSS
        }

    });

    const btn = document.querySelector(".mobile-menu-btn");
    const menu = document.querySelector(".eq_mobile_menu");

    if (btn) {
        btn.addEventListener("click", function () {
            menu.classList.toggle("active");
        });
    }

    const thumbs = new Swiper(".product-thumb-slider", {
        slidesPerView: 3.09,
        spaceBetween: 10,
        watchSlidesProgress: true,
    });

    const gallery = new Swiper(".product-main-slider", {
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },

        navigation: {
            nextEl: ".product-main-slider .swiper-button-next",
            prevEl: ".product-main-slider .swiper-button-prev",
        },

        thumbs: {
            swiper: thumbs,
        },
    });

    Fancybox.bind('[data-fancybox="product-gallery"]', {
        Thumbs: {
            autoStart: true,
        },
        Toolbar: {
            display: {
                left: [],
                middle: ["zoomIn", "zoomOut"],
                right: ["slideshow", "fullscreen", "close"],
            },
        },
    });

    // document.querySelectorAll('select[name^="options["]').forEach(select => {
    //     select.selectedIndex = 0; // Show "Choose your option"
    // });

    // Variant select: smooth show/hide via class toggling instead of inline display
    document.addEventListener('change', function (e) {
        if (!e.target.matches('.select__select')) return;

        const button = document.querySelector('.product-form__submit');
        const buttonText = button?.querySelector('span');
        const selectedOption = e.target.options[e.target.selectedIndex];

        const unavailable = selectedOption.dataset.available === 'true';

        const variantDesc = document.querySelector('.variant-desc');
        const inStock = document.querySelector('.in-stock');
        const outOfStock = document.querySelector('.out-of-stock');
        const clearLink = e.target.closest('.select-clear')?.querySelector('.clear-link') || document.querySelector('.clear-link');
        const priceValue = document.querySelector('.price-value');
        const productFormQuantity = document.querySelector('.product-form__quantity');

        if (e.target.value !== '') {
            button && (button.style.display = '');
            button && button.classList.remove('selection-needed');
            clearLink && clearLink.classList.remove('is-hidden');
            variantDesc && variantDesc.classList.remove('is-hidden');

            priceValue && priceValue.classList.remove('is-hidden');
            const itemPrice = selectedOption.dataset.price;
            const itemCompareAtPrice = selectedOption.dataset.compareAtPrice;
            if (itemPrice) {
                if (itemCompareAtPrice) {
                    priceValue && (priceValue.querySelector('.price-item--regular').textContent = itemCompareAtPrice);
                    priceValue && (priceValue.querySelector('.price-item--sale').textContent = itemPrice);
                    priceValue && priceValue.querySelector('.price')?.classList.add('price--on-sale');
                } else {
                    priceValue && (priceValue.querySelector('.price-item--regular').textContent = itemPrice);
                    priceValue && (priceValue.querySelector('.price-item--sale').textContent = '');
                    priceValue && priceValue.querySelector('.price')?.classList.remove('price--on-sale');
                }
            }

            if (!unavailable) {
                inStock && inStock.classList.remove('is-hidden');
                outOfStock && outOfStock.classList.add('is-hidden');

                buttonText && (buttonText.textContent = 'Add to cart');
                button && (button.disabled = false);

                productFormQuantity && (productFormQuantity.style.display = '');

                document.getElementsByClassName('recipient-checkbox')[0]?.click();
            } else {
                inStock && inStock.classList.add('is-hidden');
                outOfStock && outOfStock.classList.remove('is-hidden');

                buttonText && (buttonText.textContent = 'Sold out');
                button && (button.disabled = true);

                productFormQuantity && (productFormQuantity.style.display = 'none');
            }
        } else {
            button && (button.style.display = '');
            button && button.classList.add('selection-needed');
            button && (button.disabled = false);
            buttonText && (buttonText.textContent = 'Add to cart');

            variantDesc && variantDesc.classList.add('is-hidden');
            inStock && inStock.classList.add('is-hidden');
            outOfStock && outOfStock.classList.add('is-hidden');
            clearLink && clearLink.classList.add('is-hidden');
            priceValue && priceValue.classList.add('is-hidden');
            productFormQuantity && (productFormQuantity.style.display = '');
        }
    });

    document.addEventListener('click', function (e) {
        const clearBtn = e.target.closest('.clear-link');
        if (!clearBtn) return;
        e.preventDefault();

        const selectContainer = clearBtn.closest('.select-clear');
        const select = selectContainer ? selectContainer.querySelector('.select__select') : document.querySelector('.select__select');

        if (!select) return;

        select.selectedIndex = 0;
        select.dispatchEvent(new Event('change', { bubbles: true }));

        const url = new URL(window.location.href);
        url.searchParams.delete('variant');
        window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    });

    Fancybox.bind("[data-fancybox='events-gallery']", {
        Toolbar: true,
        dragToClose: false,
        animated: true,
        showClass: "fancybox-fadeIn",
        hideClass: "fancybox-fadeOut",
        Thumbs: false
    });

    // ==================================================
    // HIERARCHICAL FACETS (PARENT-CHILD FILTER SYNC)
    // ==================================================
    document.addEventListener('change', function (event) {
        const target = event.target;
        if (!(target instanceof HTMLInputElement) || target.type !== 'checkbox') return;

        const parentItem = target.closest('.has-children');
        const subItem = target.closest('.facets__subitem');

        // PARENT CHECKBOX TOGGLED
        if (parentItem && !subItem) {
            const parentCheckbox = parentItem.querySelector('.facet-parent-checkbox, :scope > .facets__parent-row input[type="checkbox"], :scope > label > input[type="checkbox"]');
            if (parentCheckbox !== target) return;

            const sublist = parentItem.querySelector('.facets__sublist');
            const toggleBtn = parentItem.querySelector('.facets__sublist-toggle');
            const isChecked = parentCheckbox.checked;

            if (sublist) {
                sublist.style.display = isChecked ? 'block' : 'none';
                parentItem.classList.toggle('is-open', isChecked);
                if (toggleBtn) {
                    toggleBtn.setAttribute('aria-expanded', isChecked ? 'true' : 'false');
                }

                // Check/uncheck all child checkboxes under this parent so their filters are applied in URL
                const childCheckboxes = sublist.querySelectorAll('input[type="checkbox"]:not(:disabled)');
                childCheckboxes.forEach((child) => {
                    child.checked = isChecked;
                });
            }
            return;
        }

        // CHILD CHECKBOX TOGGLED
        if (subItem) {
            const sublist = subItem.closest('.facets__sublist');
            if (!sublist) return;

            const parentItemForChild = sublist.closest('.has-children');
            if (!parentItemForChild) return;

            const parentCheckbox = parentItemForChild.querySelector('.facet-parent-checkbox, :scope > .facets__parent-row input[type="checkbox"], :scope > label > input[type="checkbox"]');
            const toggleBtn = parentItemForChild.querySelector('.facets__sublist-toggle');

            const allChildren = Array.from(sublist.querySelectorAll('input[type="checkbox"]:not(:disabled)'));
            const checkedChildren = Array.from(sublist.querySelectorAll('input[type="checkbox"]:not(:disabled):checked'));

            // Keep sublist expanded while at least one child is checked
            if (checkedChildren.length > 0) {
                sublist.style.display = 'block';
                parentItemForChild.classList.add('is-open');
                if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
            }

            // Sync parent checkbox: checked when all children are checked
            if (parentCheckbox) {
                parentCheckbox.checked = allChildren.length > 0 && checkedChildren.length === allChildren.length;
            }
        }
    });

    // Expand/Collapse Toggle Button Handler (Caret Button)
    document.addEventListener('click', function (event) {
        const toggleBtn = event.target.closest('.facets__sublist-toggle');
        if (!toggleBtn) return;

        event.preventDefault();
        event.stopPropagation();

        const parentItem = toggleBtn.closest('.has-children');
        if (!parentItem) return;

        const sublist = parentItem.querySelector('.facets__sublist');
        if (!sublist) return;

        const isCurrentlyOpen = sublist.style.display === 'block' || parentItem.classList.contains('is-open');
        const nextOpenState = !isCurrentlyOpen;

        sublist.style.display = nextOpenState ? 'block' : 'none';
        parentItem.classList.toggle('is-open', nextOpenState);
        toggleBtn.setAttribute('aria-expanded', nextOpenState ? 'true' : 'false');
    });
});